import api from "./api";
class PoDownloadRequest {
  #url = process.env.REACT_APP_API_URL + "/pedidos";

  #signatures_uri = "/signatures";
  #download_uri = "/download";


  async getSignatures() {
    const resp = await api.get(this.#url + this.#signatures_uri);
    return resp.data;
  }

  async download(signature , file) {

    const formData = new FormData();

    formData.append('signature', signature);
    formData.append('file', file);

    const resp = await api.post(this.#url + this.#download_uri, formData , {
      responseType: 'blob'
    });
    return resp;
  }

}

export default new PoDownloadRequest();
